import React from 'react';
import { Route, Switch, Redirect } from 'react-router';

import { PartnerInvitation } from './invitation';
import { PartnerCode } from './signin/code';
import { PartnerSignin } from './signin';
// import { PartnerSignup } from './onboarding';


export const PartnerIndex = ({ }) => {
    return (
        <Switch>
            <Route path="/auth/partner/invitation/:userId" component={PartnerInvitation} />
            <Route exact path="/auth/partner/signin/code" component={PartnerCode} />
            <Route path="/auth/partner/signin" component={PartnerSignin} />

            <Route render={() => {
                return <Redirect to="/auth/partner/invitation" />;
            }} />
        </Switch>
    );
};